// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/noise-exposure-and-hearing-loss.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/noise-exposure-and-hearing-loss/noise-exposure-and-hearing-loss.js';
import g1 from '../lessons/aeronautics/noise-exposure-and-hearing-loss/sound-variables-and-noise-levels.js';

mount([g0, g1]);
